export default "__VITE_ASSET__DsDe5jkF__"